import { FieldOptions } from './FieldOptions';

export class EsFieldsOptions {}
